import { render, staticRenderFns } from "./CreateMdtDisease.vue?vue&type=template&id=41a502e2&scoped=true"
import script from "./CreateMdtDisease.vue?vue&type=script&lang=js"
export * from "./CreateMdtDisease.vue?vue&type=script&lang=js"
import style0 from "./CreateMdtDisease.vue?vue&type=style&index=0&id=41a502e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a502e2",
  null
  
)

export default component.exports